import {action, makeAutoObservable, runInAction} from "mobx";

export default class UsersStore {
    constructor() {
        this._user = {
            email: '',
            firstName: '',
            lastName: '',
        }
        this._isAuth = false
        this._userId = null
        makeAutoObservable(this, {
            setUserId: action,
            setIsAuth: action
        })
    }

    setIsAuth(newIsAuth) {
            this._isAuth = newIsAuth

    }

    setUser(action, userItem) {
        switch (action) {
            case 'email':
                this._user.email = userItem
                break;
            case 'firstName':
                this._user.firstName = userItem
                break;
            case 'lastName':
                this._user.lastName = userItem
                break;
            default:
                return;
        }
    }

    setUserId(userId) {
        this._userId = userId
    }

    get isAuth() {
        return this._isAuth
    }

    get user() {
        return this._user
    }

    get userId() {
        return this._userId
    }
}